import { diContainer } from '../../libs/container';
import { dispatch } from '../../store';
import { loaderAction } from '../../store/slices/loader.slice';

//investigate if we can mock actions in redux so we do not need this layer

export class LoaderStateHandler {
    public pushLoaderTypeValue(key: string, value: string) {
        if (key) dispatch(loaderAction.push({ key, value }));
    }

    public popLoaderTypeValue(key: string, value: string) {
        if (key) dispatch(loaderAction.pop({ key, value }));
    }
}

diContainer.bindAsConstant(LoaderStateHandler, new LoaderStateHandler());
